import type { RadioAdapter } from '../interface'
import type { RadioChannel, SignalMessage } from '../../../types/radio'

const channelsStore: RadioChannel[] = [
  { id: '00000000-0000-0000-0000-000000000001', name: 'Общий', type: 'public', memberCount: 3, createdAt: new Date().toISOString() },
  { id: '00000000-0000-0000-0000-000000000002', name: 'Локальный', type: 'local', memberCount: 1, createdAt: new Date().toISOString() },
]

type SignalSub = (msg: SignalMessage) => void
const signalSubscribers = new Map<string, SignalSub[]>()

export const mockRadioAdapter: RadioAdapter = {
  async getChannels(): Promise<RadioChannel[]> { return [...channelsStore] },
  async createChannel(name: string): Promise<RadioChannel> {
    const ch: RadioChannel = { id: `ch_${Date.now()}`, name, type: 'group', memberCount: 1, createdAt: new Date().toISOString() }
    channelsStore.push(ch)
    return ch
  },
  async sendSignal(message: SignalMessage): Promise<void> {
    const subs = signalSubscribers.get(message.channelId) ?? []
    subs.forEach((fn) => fn(message))
  },
  subscribeToSignals(channelId: string, onSignal: SignalSub): () => void {
    if (!signalSubscribers.has(channelId)) signalSubscribers.set(channelId, [])
    signalSubscribers.get(channelId)!.push(onSignal)
    return () => {
      const subs = signalSubscribers.get(channelId) ?? []
      const idx = subs.indexOf(onSignal)
      if (idx !== -1) subs.splice(idx, 1)
    }
  },
}
